import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "添加门锁", -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_4 = ["href"];
import { Lock } from '@/entity/Lock';
import { reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserDataStore } from '@/store/userData';
import { ElMessage } from 'element-plus';
export default {
  __name: 'addlockPage',
  setup(__props) {
    const userData = useUserDataStore();
    userData.init();
    const route = useRoute();
    const router = useRouter();
    const data = reactive({
      lock: undefined,
      appLink: ""
    });
    data.lock = Lock.fromUrl(route.params.data);
    data.appLink = "yunmeiui://lock_info/" + data.lock.toString(true);
    function addLockWork() {
      let a = false;
      userData.lockList.forEach(lockDatStr => {
        if (Lock.fromUrl(lockDatStr).label == data.lock.label) {
          ElMessage("该名称已存在");
          a = true;
        }
      });
      if (a) return;
      userData.addLock(data.lock);
      router.push("/");
    }
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_hoisted_1]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createTextVNode("名字："), _createVNode(_component_el_input, {
          modelValue: data.lock.label,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.lock.label = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, null, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions, {
            title: "门锁信息",
            column: 1,
            border: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "LABEL"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.lock.label), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "S-UUID"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.lock.D_SERV), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "C-UUID"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.lock.D_CHAR), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "MAC"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.lock.D_Mac), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _hoisted_2, _hoisted_3, _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: addLockWork
        }, {
          default: _withCtx(() => [_createTextVNode("添加")]),
          _: 1
        }), _createElementVNode("a", {
          href: data.appLink,
          target: "black",
          size: "large"
        }, [_createVNode(_component_el_button, {
          type: "info"
        }, {
          default: _withCtx(() => [_createTextVNode("App打开")]),
          _: 1
        })], 8, _hoisted_4)]),
        _: 1
      })], 64);
    };
  }
};